import React from "react";

import {
  Dropdown,
  Avatar,
  Button,
  Divider,
  Form,
  Input,
  Checkbox,
  Space,
  Grid,
  Image,
  Flex,
  theme,
  Col,
  Row,
  Typography,
  Switch,
  message,
  List,
  Badge,
} from "antd";
import CustomIcon from "./CustomIcon";

import './App.css';

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Title, Text, Paragraph, Link } = Typography;

const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};
const handleMenuClick = (e) => {
  message.info("Click on menu item.");
  console.log("click", e);
};

const items = [
  {
    label: "Can edit",
    key: "1",
  },
  {
    label: "Can view",
    key: "2",
  },
];
const menuProps = {
  items,
  onClick: handleMenuClick,
};

const data = [
  {
    name: "Alice Williams",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=640&q=80",
    file: "AntBlocks UI 1.0",
    content:
      "Hey @everyone, the new AntBlocks UI 1.0 is now available for testing.",
    time: "15m ago",
  },
  {
    name: "Bob Johnson",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=640&q=80",
    file: "Project Report",
    content:
      "Hello team, attached is the latest project report detailing our progress in the last sprint. Please review it and provide your feedback during our meeting tomorrow.",
    time: "1h ago",
  },
  {
    name: "Eve Smith",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=640&q=80",
    file: "Marketing Presentation",
    content:
      "Hi team, I've prepared a marketing presentation for our upcoming product launch. The presentation covers our strategy, target audience, and key messages. Let's discuss it in our meeting next week.",
    time: "2h ago",
  },
];

export default function App() {
  const { token } = useToken();
  const screens = useBreakpoint();

  const styles = {
    wrapper: {
      backgroundColor: token.colorBgLayout,
      padding: token.paddingLG,
      maxWidth: "1440px",
      margin: "0 auto"
    },
    card: {
      padding: token.paddingLG,
      backgroundColor: token.colorBgContainer,
      borderRadius: token.borderRadiusLG,
      boxShadow: token.boxShadowTertiary,
      border: `1px solid ${token.colorBorderSecondary}`,
      position: "relative",
    },
    cardLarge: {
      padding: token.paddingXL,
      backgroundColor: token.colorBgContainer,
      borderRadius: token.borderRadiusLG,
      boxShadow: token.boxShadowTertiary,
      border: `1px solid ${token.colorBorderSecondary}`,
      position: "relative",
    },
    secondaryText: {
      color: token.colorTextSecondary,
    },
    closeButton: {
      position: "absolute",
      top: 12,
      right: 12,
    },
    image: {
      objectFit: "cover",
      borderRadius: token.borderRadius,
    },
    cardTitle: {
      margin: 0,
    },
    signupTextWrapper: {
      width: "100%",
      alignText: "center",
    },
    width100: {
      width: "100%",
    },
    cookieSwitchesWrapper: {
      marginTop: `-${token.margin}px`,
    },
    cookieSwitch: {
      padding: `${token.padding}px 0px`,
      borderBottom: `1px solid ${token.colorBorderSecondary}`,
    },
    notification: {
      backgroundColor: token.colorBgContainer,
      borderRadius: token.borderRadius,
      display: "flex",
      gap: token.margin,
      padding: `${token.paddingSM}px 0`,
      width: "100%",
    },
    preview: {
      color: token.colorTextSecondary,
      marginBottom: screens.sm ? 0 : token.marginXS,
    },
    section: {
      backgroundColor: token.colorBgContainer,
      padding: `${token.sizeXXL}px 0px`,
    },
    text: {
      color: token.colorTextSecondary,
    },
    time: {
      color: token.colorTextSecondary,
      flexShrink: 0,
    },
    title: {
      marginBottom: token.marginXXS,
    },
    titleWrapper: {
      flexGrow: 1,
    },
    content: {
      display: "flex",
      flexDirection: screens.sm ? "row" : "column",
      flexGrow: 1,
      width: "100%",
    },
    contentWrapper: {
      alignItems: "space-between",
      display: "flex",
      width: "100%",
    },
    margin0: {
      margin: 0
    }
  };

  return (
    <div style={styles.wrapper}>
      <Row gutter={[token.marginLG, token.marginLG]}>
        <Col span={screens.lg ? 8 : 24}>
          <Flex vertical gap={token.marginLG}>
            <div style={styles.card}>
              <Button
                style={styles.closeButton}
                type="text"
                size="small"
                icon={<CustomIcon type="x" />}
              />
              <Flex vertical gap={token.marginLG}>
                <Flex vertical gap={token.marginXS}>
                  <Title style={styles.cardTitle} level={5}>
                    Let's set up your branding
                  </Title>
                  <Text style={styles.secondaryText}>
                    Customize your workspace with colors, corner radius and
                    typography to match your brand's styling.
                  </Text>
                </Flex>
                <Image
                  style={styles.image}
                  width={"100%"}
                  height={200}
                  preview={false}
                  src="https://images.unsplash.com/photo-1600832331197-ad575931911b?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                />
                <Flex justify="space-between" align="center">
                  <Text>2 of 4</Text>
                  <Space>
                    <Button>Previous</Button>
                    <Button type="primary">Next</Button>
                  </Space>
                </Flex>
              </Flex>
            </div>
            <div style={styles.card}>
              <Flex justify="space-between">
                <Title style={styles.cardTitle} level={5}>
                  Notifications
                </Title>
                <Link underline style={styles.secondaryText}>
                  Mark all as read
                </Link>
              </Flex>
              <List
                dataSource={data}
                renderItem={(item, index) => (
                  <List.Item>
                    <div style={styles.notification}>
                      <Badge dot>
                        <Avatar
                          alt={item.name}
                          src={item.avatar}
                          shape="square"
                        />
                      </Badge>
                      <div style={styles.contentWrapper}>
                        <div style={styles.content}>
                          <div style={styles.titleWrapper}>
                            <div style={styles.title}>
                              <Text strong>{item.name}</Text>
                              <Text style={styles.text}>
                                {" "}
                                added a comment in{" "}
                              </Text>
                              <Text strong>{item.file}</Text>
                            </div>
                            <Paragraph
                              ellipsis={{ rows: 2 }}
                              style={styles.preview}
                            >
                              {item.content}
                            </Paragraph>
                          </div>
                          <Text style={styles.time}>{item.time}</Text>
                        </div>
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          </Flex>
        </Col>
        <Col span={screens.lg ? 8 : 24}>
          <Flex vertical gap={token.marginLG}>
            <div style={styles.cardLarge}>
              <Flex vertical gap={token.marginLG}>
                <Flex vertical gap={token.marginXS}>
                  <Title style={styles.cardTitle} level={4}>
                    Sign in
                  </Title>
                  <Text style={styles.secondaryText}>
                    Enter your details to sign in with email and password.
                  </Text>
                </Flex>
                <Form
                  name="login"
                  layout="vertical"
                  requiredMark={false}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    req
                    rules={[
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>

                  <Form.Item name="remember" valuePropName="checked">
                    <Flex align="center" justify="space-between">
                      <Checkbox>Remember me</Checkbox>
                      <Link
                        href="https://antblocksui.com/"
                        target="_blank"
                        underline
                      >
                        Forgot password?
                      </Link>
                    </Flex>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      style={styles.width100}
                      type="primary"
                      htmlType="submit"
                    >
                      Sign in
                    </Button>
                  </Form.Item>
                  <Flex vertical>
                    <Flex justify="center" gap={token.marginXXS}>
                      <Text>Don't have an account? </Text>
                      <Link
                        href="https://antblocksui.com/"
                        target="_blank"
                        underline
                      >
                        Sign up
                      </Link>
                    </Flex>
                    <Divider plain>or</Divider>
                    <Button icon={<CustomIcon type="BrandGoogleFilled" />}>
                      Sign in with Google
                    </Button>
                  </Flex>
                </Form>
              </Flex>
            </div>
            <div style={styles.card}>
              <Button
                style={styles.closeButton}
                type="text"
                size="small"
                icon={<CustomIcon type="x" />}
              />
              <Flex vertical gap={token.marginLG}>
                <svg
                  width="49"
                  height="48"
                  viewBox="0 0 49 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.333252 8C0.333252 3.58172 3.91497 0 8.33325 0H40.3333C44.7515 0 48.3333 3.58172 48.3333 8V40C48.3333 44.4183 44.7515 48 40.3333 48H8.33325C3.91497 48 0.333252 44.4183 0.333252 40V8Z"
                    fill={token.colorText}
                  />
                  <path
                    d="M27.3333 21C28.1289 21 28.892 21.3161 29.4546 21.8787C30.0172 22.4413 30.3333 23.2044 30.3333 24C30.3333 24.7956 30.0172 25.5587 29.4546 26.1213C28.892 26.6839 28.1289 27 27.3333 27C26.5376 27 25.7745 26.6839 25.2119 26.1213C24.6493 25.5587 24.3333 24.7956 24.3333 24C24.3333 23.2044 24.6493 22.4413 25.2119 21.8787C25.7745 21.3161 26.5376 21 27.3333 21ZM27.3333 21C28.1289 21 28.892 20.6839 29.4546 20.1213C30.0172 19.5587 30.3333 18.7956 30.3333 18C30.3333 17.2044 30.0172 16.4413 29.4546 15.8787C28.892 15.3161 28.1289 15 27.3333 15H21.3333C20.5376 15 19.7745 15.3161 19.2119 15.8787C18.6493 16.4413 18.3333 17.2044 18.3333 18C18.3333 18.7956 18.6493 19.5587 19.2119 20.1213C19.7745 20.6839 20.5376 21 21.3333 21M27.3333 21H21.3333M21.3333 21C20.5376 21 19.7745 21.3161 19.2119 21.8787C18.6493 22.4413 18.3333 23.2044 18.3333 24C18.3333 24.7956 18.6493 25.5587 19.2119 26.1213C19.7745 26.6839 20.5376 27 21.3333 27M21.3333 27H24.3333M21.3333 27C20.7399 27 20.1599 27.1759 19.6665 27.5056C19.1732 27.8352 18.7887 28.3038 18.5616 28.8519C18.3346 29.4001 18.2751 30.0033 18.3909 30.5853C18.5067 31.1672 18.7924 31.7018 19.2119 32.1213C19.6315 32.5409 20.166 32.8266 20.748 32.9424C21.3299 33.0581 21.9331 32.9987 22.4813 32.7716C23.0295 32.5446 23.498 32.1601 23.8277 31.6667C24.1573 31.1734 24.3333 30.5933 24.3333 30V15"
                    stroke={token.colorTextInverse}
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <Flex vertical gap={token.marginXS}>
                  <Title style={styles.cardTitle} level={4}>
                    Connect to Figma
                  </Title>
                  <Text style={styles.secondaryText}>
                    Integrate Figma into your application to fully manage
                    projects in your workspace.{" "}
                  </Text>
                </Flex>
                <Flex vertical gap={token.marginXS}>
                  <Text strong>Figma would like to:</Text>
                  <ul
                    style={{
                      "list-style-type": "none",
                      padding: 0,
                      margin: 0,
                      display: "flex",
                      flexDirection: "column",
                      gap: token.marginXS,
                    }}
                  >
                    <li>
                      <Space style={{ color: token.colorPrimary }}>
                        <CustomIcon type="check" />
                        <Text style={styles.secondaryText}>
                          Access account information and details
                        </Text>
                      </Space>
                    </li>
                    <li>
                      <Space style={{ color: token.colorPrimary }}>
                        <CustomIcon type="check" />
                        <Text style={styles.secondaryText}>
                          Assign project and change user roles
                        </Text>
                      </Space>
                    </li>
                    <li>
                      <Space style={{ color: token.colorPrimary }}>
                        <CustomIcon type="check" />
                        <Text style={styles.secondaryText}>
                          Create, edit, and delete projects
                        </Text>
                      </Space>
                    </li>
                  </ul>
                </Flex>
                <Flex justify="flex-end" align="center">
                  <Space>
                    <Button>Cancel</Button>
                    <Button type="primary">Confirm</Button>
                  </Space>
                </Flex>
              </Flex>
            </div>
          </Flex>
        </Col>
        <Col span={screens.lg ? 8 : 24}>
          <Flex vertical gap={token.marginLG}>
            <div style={styles.card}>
              <Button
                style={styles.closeButton}
                type="text"
                size="small"
                icon={<CustomIcon type="x" />}
              />
              <div
                style={{
                  fontSize: token.sizeLG,
                  color: token.colorSuccess,
                  position: "absolute",
                  left: token.marginLG,
                }}
              >
                <CustomIcon type="CircleCheckFilled" />
              </div>
              <Flex vertical gap={token.marginLG}>
                <Flex
                  vertical
                  gap={token.marginXS}
                  style={{ paddingLeft: "40px" }}
                >
                  <Title style={styles.cardTitle} level={5}>
                    Payment received
                  </Title>
                  <Text style={styles.secondaryText}>
                    Your payment has been successfully received. You have
                    unlocked the full version.{" "}
                  </Text>
                </Flex>

                <Flex justify="flex-end" gap={token.marginXS}>
                  <Button size="small" type="text">
                    Dismiss
                  </Button>
                  <Button size="small" type="primary">
                    View details
                  </Button>
                </Flex>
              </Flex>
            </div>
            <div style={styles.card}>
              <Button
                style={styles.closeButton}
                type="text"
                size="small"
                icon={<CustomIcon type="x" />}
              />
              <Flex vertical gap={token.marginLG}>
                <Flex vertical gap={token.marginXS}>
                  <Title style={styles.cardTitle} level={5}>
                    Privacy preferences
                  </Title>
                  <Text style={styles.secondaryText}>
                    Your privacy is important to us. By enabling certain types
                    of cookies, you can enjoy a tailored browsing experience.
                  </Text>
                </Flex>
                <div style={styles.cookieSwitchesWrapper}>
                  <Flex style={styles.cookieSwitch} justify="space-between">
                    <Text strong>Essential cookies</Text>
                    <Switch defaultChecked />
                  </Flex>
                  <Flex style={styles.cookieSwitch} justify="space-between">
                    <Text strong>Functional cookies</Text>
                    <Switch />
                  </Flex>
                  <Flex style={styles.cookieSwitch} justify="space-between">
                    <Text strong>Performance cookies</Text>
                    <Switch />
                  </Flex>
                </div>
                <Flex justify="flex-end">
                  <Button type="primary">Save preferences</Button>
                </Flex>
              </Flex>
            </div>
            <div style={styles.card}>
              <Button
                style={styles.closeButton}
                type="text"
                size="small"
                icon={<CustomIcon type="x" />}
              />
              <Flex vertical gap={token.marginLG}>
                <Flex vertical gap={token.marginXS}>
                  <Title style={styles.cardTitle} level={5}>
                    Invite team members
                  </Title>
                  <Text style={styles.secondaryText}>
                    Add your colleagues to collaborate by inviting them to join
                    your team.
                  </Text>
                </Flex>
                <Form
                  name="team"
                  style={{ display: "flex", gap: token.margin }}
                >
                  <Form.Item style={{ margin: 0, width: "100%" }}>
                    <Input placeholder="E-mail"></Input>
                  </Form.Item>
                  <Form.Item style={{ margin: 0 }}>
                    <Button type="primary">Send invite</Button>
                  </Form.Item>
                </Form>
                <Divider style={{ margin: 0 }} />
                <Flex vertical gap={token.marginSM}>
                  <Text strong>Team members</Text>
                  <Flex justify="space-between" align="center">
                    <Space>
                      <Avatar
                        size="default"
                        src="https://images.unsplash.com/photo-1548361403-cb0c785eea54?q=80&w=3617&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      ></Avatar>
                      <Text strong>Natalie Lin</Text>
                    </Space>
                    <Dropdown menu={menuProps}>
                      <Button
                        iconPosition="end"
                        icon={<CustomIcon type="ChevronDown" />}
                        style={{ width: "116px" }}
                      >
                        Can edit
                      </Button>
                    </Dropdown>
                  </Flex>
                  <Flex justify="space-between" align="center">
                    <Space>
                      <Avatar
                        size="default"
                        src="https://images.unsplash.com/photo-1583674392771-2abf6be75965?q=80&w=4073&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      ></Avatar>
                      <Text strong>Roger Doroszewicz</Text>
                    </Space>
                    <Dropdown menu={menuProps}>
                      <Button
                        iconPosition="end"
                        icon={<CustomIcon type="ChevronDown" />}
                        style={{ width: "116px" }}
                      >
                        Can view
                      </Button>
                    </Dropdown>
                  </Flex>
                  <Flex justify="space-between" align="center">
                    <Space>
                      <Avatar
                        size="default"
                        src="https://images.unsplash.com/photo-1507101105822-7472b28e22ac?q=80&w=5073&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      ></Avatar>
                      <Text strong>Gabrielle Willis</Text>
                    </Space>
                    <Dropdown menu={menuProps}>
                      <Button
                        iconPosition="end"
                        icon={<CustomIcon type="ChevronDown" />}
                        style={{ width: "116px" }}
                      >
                        Can edit
                      </Button>
                    </Dropdown>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </Flex>
        </Col>
      </Row>
    </div>
  );
}
